import { ThemeName } from './themes/ITheme';

export const gameThemeMap: Record<string, ThemeName> = {
  // Slots
  'pirates-fortune': 'piratesFortune',
  'pirates-awakening': 'piratesFortune',
  'eye-of-the-reels': 'eyeOfTheReels',

  // Adventure
  'predator-path': 'predatorPath',

  // Crash Games
  crash: 'skyx',
  'sky-x': 'skyxNew',
  skyx: 'skyx',
  skyx_new: 'skyxNew',
  'skyX2(Crash Game)': 'crashAlt',
  'sky-sniffer': 'skysniffer',
  skysniffer: 'skysniffer',
  'city-sniffer': 'skysniffer',
  superdog: 'skyx',

  // Aviator Games
  aviator: 'skyx',

  // Default theme for when no game is selected (i.e., the lobby)
  default: 'skyx',
};
